class User {
    constructor(response) {
        this.status = response.status
        this.id = response.data.id || null;
        this.uid = response.data.uid || '';
        this.email = response.data.email || '';
        this.type = response.data.type || '';
        this.isActive = response.data.is_active || false;
        this.isAdmin = response.data.is_admin || false;
        this.isAnonymous = response.data.is_anonymous || false;
        this.isApproveNeeded = response.data.is_approve_needed || false;
        this.isApproved = response.data.is_approved || false;
        this.isAuthenticated = response.data.is_authenticated || false;
        this.isStaff = response.data.is_staff || false;
        this.isSuperuser = response.data.is_superuser || false;
        this.lastLogin = response.data.last_login || null;
        this.firstName = response.data.first_name || '';
        this.lastName = response.data.last_name || '';
        this.clientLocationId = response.data.client_location_id || null;
        this.clientLocationName = response.data.client_location_name || '';
        this.countryCode = response.data.country_code || null;
        this.profilePic = response.data.profile_pic || '';
        this.geckoRole = response.data.gecko_role || null;
        this.geckoRoleName = response.data.gecko_role_name || '';
        this.assignedLocations = response.data.assigned_locations || [];

        this.channelId = response.data.channel.channelId || null;
        this.channelName = response.data.channel.channelName || '';
        this.channelType = response.data.channel.channelType || '';
        this.secretsKey = response.data.channel.secretsKey || null;
        this.channelStatus = response.data.channel.status || '';
        this.webhookUrl = response.data.channel.webhookConfig.webhookUrl || '';

        this.isLaas = response.data.channel.client_configuration?.is_laas || false;
        this.isSaas = response.data.channel.client_configuration?.is_saas || false;
        this.lastMile = response.data.channel.client_configuration?.last_mile || false;
        this.sortCode = response.data.channel.client_configuration?.sort_code || false;
        this.taskCreate = response.data.channel.client_configuration?.task_create || false;
        this.eywaRecommendation = response.data.channel.client_configuration?.eywa_recommendation || false;
        this.navikRecommendation = response.data.channel.client_configuration?.navik_recommendation || false;
        this.alterReferenceNumber = response.data.channel.client_configuration?.alter_reference_number || false;

        this.geckoPermissions = {
            analytics: response.data.gecko_permissions.analytics || false,
            bookOrder: response.data.gecko_permissions.book_order || false,
            midMileRouteOptimization: response.data.gecko_permissions.midmile_route_optimization || false
        };
    }
}

export default User;